import type { ScreenBase } from "@frui.ts/screens";
import { ConductorOneChildActive, Router } from "@frui.ts/screens";
import { computed } from "mobx";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import MunicipalitiesViewModel from "./municipalities/municipalitiesViewModel";
import RegionsViewModel from "./regions/regionsViewModel";
import RoadsViewModel from "./roads/roadsViewModel";
import CountriesViewModel from "./countries/countriesViewModel";

const navigationName = "distributor-enums";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [RegionsViewModel, MunicipalitiesViewModel, RoadsViewModel],
})
export default class DistributorEnumsViewModel extends ConductorOneChildActive<ScreenBase> {
  constructor(
    private localizationService: LocalizationService,
    private regionsViewModel: RegionsViewModel,
    private municipalitiesViewModel: MunicipalitiesViewModel,
    private roadsViewModel: RoadsViewModel,
    private countriesViewModel: CountriesViewModel
  ) {
    super();
    this.navigationName = navigationName;
    this.children.push(this.countriesViewModel, this.regionsViewModel, this.municipalitiesViewModel, this.roadsViewModel);
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  closeChild(child: ScreenBase) {
    return false;
  }

  @computed
  get name() {
    return this.translate("name");
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.timeCharges, `distributorEnums.${code}`, size);
  }
}
